import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import getStaticPagesByType from 'lib/getStaticPagesByType'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import BodyText from 'components/Luxkit/Typography/BodyText'

const Root = styled.nav`
  display: none;

  ${mediaQueryUp.sm} {
    position: sticky;
    top: ${rem(130)};
    display: block;
    margin-top: ${rem(120)};
  }
`

const InfoItem = styled(ClickableLink)`
  display: block;
  color: ${({ theme }) => theme.palette.neutral.four};

  & + & {
    margin-top: ${rem(25)};
  }
`

const types = [
  'termsAndConditions',
  'bookingPolicies',
  'privacyPolicy',
  'flights',
  'frequentFlyerPrograms',
  'bestPriceTerms',
  'giftcardTermsAndConditions',
  'specialProductsPromotions',
  'feeSchedule',
]

function InfoSideBar() {
  return (
    <Root>
      {getStaticPagesByType(types).map((item) => <InfoItem
        key={item.type}
        role="menuitem"
        to={item.url.to}
      >
        <BodyText variant="medium" weight="bold" format="uppercase" as="span">
          {item.text}
        </BodyText>
      </InfoItem>)}
    </Root>
  )
}

export default InfoSideBar
